export const BLOG_TYPE_OPTIONS = [
  { label: "Default", value: "default" },
  { label: "Partner", value: "partner" }, //Partner Api not available
  { label: "Announcement", value: "announcement" },
  { label: "Career Guides", value: "career_guides" },
  { label: "Testimonial", value: "testimonials" },
  { label: "News", value: "news" },
];
